import React from 'react';
import { Link } from 'components/navigation/Link/Link';
import { ReactComponent as ArrowRight } from 'style/_assets/icons/arrow-right.svg';
import './SeeAllCards.scss';
import { CREDIT_CARD_VERTICAL } from 'types/marketplaceTiles.constants';
import { useHistory } from 'react-router-dom';

export const SeeAllCards = props => {
  const {
    sizeClass,
    description,
    link,
    onLinkClickCallback,
    module,
    extraEventAttributes,
    location,
    childrenIcon,
    labelClassName,
  } = props;
  const history = useHistory();
  const iconToShow = childrenIcon ?? <Checkmark />;
  const labelStyle = labelClassName ?? 'secondary_text_light';
  return (
    <div className={'seeallcards ' + sizeClass}>
      <Link
        to={link}
        onClickCallback={onLinkClickCallback}
        link={description}
        module={module}
        extraEventAttributes={extraEventAttributes}
        location={location}
        Vertical={CREDIT_CARD_VERTICAL}
        ariaLabel={description}
      >
        <div className="seeallcards-containers">
          {iconToShow}
          {description}
        </div>
      </Link>
    </div>
  );
};

const Checkmark = () => {
  return (
    <div className="seeallcards">
      <ArrowRight width="25px" height="25px" aria-hidden="true" />
    </div>
  );
};
